/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// Break product titles at dash for Prestige theme and make measurements extra bold
document.addEventListener('DOMContentLoaded', function() {
  // For product pages
  var productTitle = document.querySelector('.product-meta__title, .ProductMeta__Title, h1.product__title');
  if (productTitle) {
    var parts = productTitle.innerHTML.split(' – ');
    if (parts.length === 2) {
      productTitle.innerHTML = parts[0] + '<br><span style="font-weight: 900;">' + parts[1] + '</span>';
    }
  }
  
  // For collection pages
  document.querySelectorAll('.product-item__title, .ProductItem__Title, .card__heading a').forEach(function(title) {
    var parts = title.innerHTML.split(' – ');
    if (parts.length === 2) {
      title.innerHTML = parts[0] + '<br><span style="font-weight: 900;">' + parts[1] + '</span>';
    }
  });
});


